import React from 'react';
import { IProps } from './types';
import { SignupGender } from 'constants/enums/signupGender.enum';
import { Marriage } from 'constants/enums/marriage.enum';
import { HearingState } from 'constants/enums/hearingState.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import commonService from 'utils/commonService';

const MemberProfileList: React.FC<IProps> = (props) => {
  /**
   * @description 會員資料註冊 取得 OTP 驗證碼方法
   */
  const handleFetchOTP = () => {
    props.onFetchOTP(props.memberProfile);
  };

  return (
    <div className="member-profile-list">
      <div className="member-profile-list__title">會員資料</div>
      <div className="member-profile-list__content">
        <div className="element__list">
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">帳號*</div>
              <div className="element__list-group-content">{props.memberProfile.MEMBER_ID}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">性別</div>
              <div className="element__list-group-content">{props.memberProfile.GENDER === SignupGender.Male ? '男' : '女'}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">姓名*</div>
              <div className="element__list-group-content">{props.memberProfile.NAME}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">生日*</div>
              <div className="element__list-group-content">
                {
                  props.memberProfile.BIRTHDAY.replace(/^([\d]{4})([\d]{2})([\d]{2})$/, '$1/$2/$3')
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">手機號碼*</div>
              <div className="element__list-group-content">{props.memberProfile.MOBILE}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">住家電話</div>
              <div className="element__list-group-content">
                {
                  props.memberProfile.HOME_TEL_AREA_CODE ? `(${props.memberProfile.HOME_TEL_AREA_CODE})` : ''
                }
                {
                  `${props.memberProfile.HOME_TEL_NUMBER ?? ''}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">電子信箱*</div>
              <div className="element__list-group-content">{props.memberProfile.EMAIL_ADDR}</div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">通訊地址</div>
              <div className="element__list-group-content">
                {
                  `${props.memberProfile.POST_CODE} ${props.memberProfile.CITY_NAME}${props.memberProfile.AREA_NAME}${props.memberProfile.ADDRESS}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">國籍*</div>
              <div className="element__list-group-content">
                {
                  `${props.memberProfile.NATIONALITY_TYPE_NAME} ${props.memberProfile.NATIONALITY_ID_NAME}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">婚姻狀況</div>
              <div className="element__list-group-content">
                {
                  props.memberProfile.MARRIAGE === Marriage.Married
                    ? '已婚'
                    : props.memberProfile.MARRIAGE === Marriage.Single
                      ? '未婚'
                      : ''
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">職業</div>
              <div className="element__list-group-content">
                {
                  props.memberProfile.OCCUPATION_DOMAIN_ID_NAME
                }
                <br />
                {
                  props.memberProfile.OCCUPATION_ID_NAME
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">是否為聽障人士*</div>
              <div className="element__list-group-content">
                {
                  props.memberProfile.HEARING_DISABILITY === HearingState.Disability
                    ? '是'
                    : props.memberProfile.HEARING_DISABILITY === HearingState.Ability
                      ? '否'
                      : ''
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            <div className="element__list-group">
              <div className="element__list-group-title">安全問題</div>
              <div className="element__list-group-content">
                {
                  `${props.memberProfile.SECQUE_QUESTION} ${props.memberProfile.SECQUE_ANSWER}`
                }
              </div>
            </div>
          </div>
          <div className="element__list-col">
            {
              /**
              <div className="element__checkbox-group">
                <label htmlFor="app-auth-checkbox">
                  <div className="element__checkbox">
                    <input type="checkbox" name="appAuth" id="app-auth-checkbox" disabled checked={props.memberProfile.MEMBERSHIP?.includes(SignupMembership.App)} />
                    <div className="element__checkbox-btn" />
                  </div>
                  <span>請勾選「同步加入 app 會員」或直接下載「旺旺友聯 app」進行會員身分驗證及註冊。</span>
                </label>
              </div>
              */
            }
            <div className="element__checkbox-group">
              <label htmlFor="receive-information-checkbox">
                <div className="element__checkbox">
                  <input type="checkbox" name="receiveInformation" id="receive-information-checkbox" disabled checked={(props.memberProfile.EDM_SUBSCRIBE_TIME as number) > 0} />
                  <div className="element__checkbox-btn" />
                </div>
                <span>{commonService.getCodeMsg(props.UICode, CodeId.U016)}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div className="member-profile-list__controls">
        <button type="button" className="element__button element__button--red-border" onClick={props.onGoBack}>返回上一頁</button>
        <button type="button" className="element__button element__button--red" onClick={handleFetchOTP}>發送 OTP 驗證</button>
      </div>
    </div>
  );
};

export default MemberProfileList;
